import { useState, useEffect } from "react";
import { Canvas } from "@react-three/fiber";
import { Perf } from "r3f-perf";
import {
    Room,
    Modal,
    Panel,
    Light,
    LightPanel,
    EdgePanel,
    ViewMenu,
    Mirrors,
    Control,
    Environment,
} from "components";
import {
    getMaterials,
    getCarpetMaterial,
    getSeamMaterial,
    createEdge,
    changeMaterial,
    getWallpaper,
    createMaterials,
} from "helpers";
import { getMaterial } from "materials";

const Scene = ({ settings, startMeshes, mirrors, isFree, isShowPerf }) => {
    const [showModal, setShowModal] = useState(false);
    const [showLightPanel, setShowLightPanel] = useState(false);
    const [showViewMenu, setShowViewMenu] = useState(false);
    const [selectedMesh, setSelectedMesh] = useState(null);
    const [selectedAnyMesh, setSelectedAnyMesh] = useState(null);
    const [selectedEdge, setSelectedEdge] = useState(null);
    const [meshes, setMeshes] = useState(startMeshes);
    const [isFloor, setIsFloor] = useState();
    const [isShowerFloor, setIsShoweFloor] = useState();
    const [isLightOn, setIsLightOn] = useState(true);
    // const [isFree, setIsFree] = useState(false);
    const [isWallLightOn, setIsWallLightOn] = useState(true);
    const [settingsLight, setSettingsLight] = useState({
        mainIntensity: 0.19,
        mainColor: "#ffffff",
        wallIntensity: 1,
        wallColor: "#ffffff",
        // numberSources: 1,
        // sunIntensity: 0.1,
        // sunPosition: 4,
    });

    // console.log("SCENE");

    useEffect(() => {
        window.addEventListener("keydown", openAdditionalPanel);
        return () => window.removeEventListener("keydown", openAdditionalPanel);
    }, []);

    const openAdditionalPanel = (event) => {
        if (event.code === "KeyL") {
            setShowLightPanel(true);
        }
        if (event.code === "KeyV") {
            setShowViewMenu(true);
        }
        // if (event.code === "KeyF") {
        //     setIsFree((prev) => !prev);
        // }
    };

    const handleLight = (settings) => {
        setSettingsLight(settings);
    };

    const selectEdge = (edge) => {
        setSelectedEdge(edge);
    };

    const selectMesh = (mesh) => {
        const name = meshes[mesh].name;
        console.log("meshes[mesh]: ", meshes[mesh].geometry);
        console.log("name: ", name);

        if (name === "Mesh018" || name === "Switch_01") {
            setIsLightOn((prev) => !prev);
        }
        if (name === "Mesh034" || name === "Mesh034_1") {
            setIsWallLightOn((prev) => !prev);
        }

        if (settings.availableMeshes.includes(name)) {
            // meshes[mesh].material.wireframe = !meshes[mesh].material.wireframe;
            // meshes[mesh].material.needsUpdate = true;

            setSelectedMesh(mesh);
            setShowModal(true);
            if (name === "Floor_Grout" || name === "Floor_1") setIsFloor(true);
            else setIsFloor(false);
            if (name === "Drain") setIsShoweFloor(true);
            else setIsShoweFloor(false);
        }
        setSelectedAnyMesh(mesh);
    };

    const handleMaterial = (material) => {
        const mesh = meshes[selectedAnyMesh];
        const group1 = ["Trimming", "Mesh014", "Mesh014_1"];
        const group2 = ["Skirting_Mesh_1", "Door_Frame"];
        const group = group1.includes(mesh.name) ? group1 : group2;

        if (group.includes(mesh.name)) {
            const indexes = group.map((meshName) =>
                meshes.findIndex(({ name }) => name === meshName)
            );
            indexes.forEach((index) => {
                changeMaterial(meshes[index].material, material);
            });
        } else changeMaterial(mesh.material, material);
        setMeshes((prev) => [...prev]);
    };

    const addTile = (options) => {
        if (selectedMesh) {
            let seamMaterial, tileMaterial;
            const mesh = meshes[selectedMesh];

            if (options.isTile) {
                if (options.isPlastic) {
                    seamMaterial = getMaterial("plastic", "rgb(255,255,255)");
                } else if (options.options === "tile") {
                    if (options.tiling !== "whole") {
                        /////////
                        handleSubmit(options); /////////////
                        return; //////////////
                    } /////////////
                    [seamMaterial, tileMaterial] = getMaterials(mesh, options);
                } else if (options.options === "paint")
                    seamMaterial = getSeamMaterial(options.seamColor);
                else seamMaterial = getWallpaper(options.texture, options.rollWidth);
            } else {
                const { texture, inches, length, floorRotate, floorColor } = options;

                seamMaterial = getCarpetMaterial(texture, inches, length, floorRotate, floorColor);

                tileMaterial = null;
            }

            seamMaterial.needsUpdate = true; /////

            if (mesh.name === "Floor_Grout" || mesh.name === "Floor_1") {
                setMeshes((prev) => {
                    const result = [...prev];
                    result[selectedMesh].material = seamMaterial;
                    result[selectedMesh].userData.tile = tileMaterial;
                    return result;
                });
            } else {
                const group = settings.group1.includes(mesh.name)
                    ? settings.group1
                    : settings.group2.includes(mesh.name)
                    ? settings.group2
                    : settings.group3;

                const indexes = group.map((nameWall) =>
                    meshes.findIndex(({ name }) => name === nameWall)
                );

                setMeshes((prev) => {
                    const result = [...prev];

                    indexes.forEach((index) => {
                        result[index].material = seamMaterial;
                        result[index].userData.tile = tileMaterial;

                        result[index].userData.groutTop = null;
                        result[index].userData.groutBottom = null;
                        result[index].userData.tileTop = null;
                        result[index].userData.tileBottom = null;
                    });

                    // result[selectedMesh].material = seamMaterial;
                    // result[selectedMesh].userData.tile = tileMaterial;

                    return result;
                });
            }
        }
    };

    const addEdge = () => {
        const mesh = meshes[selectedMesh];
        const edge = createEdge(mesh);
        const edges = mesh.userData.edges || [];

        setMeshes((prev) => {
            const result = [...prev];
            result[selectedMesh].userData.edges = [...edges, edge];
            return result;
        });
        selectEdge(edge);
    };

    const changeEdge = () => {
        setMeshes((prev) => [...prev]);
    };

    const removeEdge = () => {
        const edges = selectedEdge.wall.userData.edges;

        const edgeIndex = edges.findIndex(({ uuid }) => uuid === selectedEdge.uuid);

        edges.splice(edgeIndex, 1);

        setMeshes((prev) => [...prev]);
        setSelectedEdge(null);
    };

    const handleSubmit = (options) => {
        let groutTop, groutBottom, tileTop, tileBottom;
        const mesh = meshes[selectedMesh];

        [groutTop, groutBottom, tileTop, tileBottom] = createMaterials(mesh, options);

        setMeshes((prev) => {
            const result = [...prev];

            result[selectedMesh].userData.groutTop = groutTop;
            result[selectedMesh].userData.groutBottom = groutBottom;
            result[selectedMesh].userData.tileTop = tileTop;
            result[selectedMesh].userData.tileBottom = tileBottom;
            return result;
        });
    };

    return (
        <>
            <Canvas
                camera={{
                    fov: 50,
                    near: 0.1,
                    far: 50,
                    position: settings.cameraPos,
                }}
                shadows="soft"
                frameloop={isShowPerf ? "always" : "demand"}
                linear={true}
            >
                {isShowPerf && <Perf />}
                <Room meshes={meshes} selectMesh={selectMesh} selectEdge={selectEdge} />
                <Mirrors mirrors={mirrors} type={settings.envPos[1]} />
                <Light
                    lights={settings.lights}
                    isLightOn={isLightOn}
                    isWallLightOn={isWallLightOn}
                    settings={settingsLight}
                />
                <Control isFree={isFree} box={settings.cameraBox} target={settings.cameraPos} />
                <Environment pos={settings.envPos} />
            </Canvas>
            {showModal && (
                <Modal close={() => setShowModal(false)}>
                    <Panel
                        submit={addTile}
                        isFloor={isFloor}
                        isShowerFloor={isShowerFloor}
                        addEdge={() => addEdge(null, true)}
                    />
                </Modal>
            )}
            {showLightPanel && (
                <Modal close={() => setShowLightPanel(false)}>
                    <LightPanel submit={handleLight} />
                </Modal>
            )}
            {showViewMenu && (
                <Modal close={() => setShowViewMenu(false)} st={{ left: "400px" }}>
                    <ViewMenu submit={handleMaterial} />
                </Modal>
            )}
            {selectedEdge && (
                <Modal close={() => setSelectedEdge(false)} st={{ top: "500px", left: "350px" }}>
                    <EdgePanel submit={changeEdge} edge={selectedEdge} removeEdge={removeEdge} />
                </Modal>
            )}
        </>
    );
};

export default Scene;
